export default {
    contentModuleRow: {
        display: 'grid',
        gridTemplateColumns: '70% 30%',
    },
    contentModuleCellPrice: {
        textAlign: 'end',
    },
    textoverflow: {},
    contentModuleCellName: {
        '& $textoverflow': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        }
    },
    textPrice: {
        fontWeight: '400',
    }
}